var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-layout',{staticClass:"layout-3"},[_c('a-page-header',{staticStyle:{"border-bottom":"1px solid #dedede"},attrs:{"ghost":false,"title":_vm.pageTitle,"breadcrumb":{
      props: { routes: _vm.routes, itemRender: _vm.itemRender },
    }}}),_c('router-view',{staticClass:"content-body"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }